export { default } from './palette';
export * from './palette';
